import { render, staticRenderFns } from "./VademecumList.vue?vue&type=template&id=81279456&scoped=true&lang=pug"
import script from "./VademecumList.vue?vue&type=script&lang=js"
export * from "./VademecumList.vue?vue&type=script&lang=js"
import style0 from "./VademecumList.vue?vue&type=style&index=0&id=81279456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81279456",
  null
  
)

export default component.exports